import {createNamespacedHelpers} from 'vuex'
import { required, minValue, integer } from 'vuelidate/lib/validators'

const { mapActions: mapCartActions, mapGetters: mapCartGetters } = createNamespacedHelpers('Shop/Orders/Cart')

export default {
  props: {
    publishZone: {
      type: String,
      default: '',
    },
  },

  data: () => ({
    editMode: false,
    editItem: null,
    playcardProducts: null,
    playcardProductId: null,
    playcardQuantity: null,
    isAddingToCart: false,
  }),

  validations() {
    return {
      playcardProductId: {
        required,
      },
      playcardQuantity: {
        required,
        minValue: minValue(1),
        integer,
      },
      ...(this.addedValidations ? this.addedValidations() : {})
    }
  },

  created() {
    const products = window.addiesaas.products.types.playcard_voucher || []
    this.playcardProducts = products.filter(x => (x.publish_zones || ['']).includes(this.publishZone))
  },

  computed: {
    ...mapCartGetters(['cartItems']),

    playcardProduct() {
      return this.playcardProducts.find(x => x.id == this.playcardProductId)
    },

    addingToCartDisabled() {
      return this.$v.playcardProductId.$error || this.$v.playcardQuantity.$invalid
    },
  },

  methods: {
    ...mapCartActions(['addCartItem', 'removeCartItem']),
    setEditItem(id) {
      if (this.cartItems[id] && this.cartItems[id].type === 'playcard_voucher') {
        this.editItem = this.cartItems[id]
        this.editMode = true
        this.playcardProductId = this.editItem.payload.product_id
        this.playcardQuantity = this.editItem.payload.count
      }
    },

    getPlaycardCartItem() {
      const item = {
        type: 'playcard_voucher',
        total: this.playcardProduct.price,
        count: this.playcardQuantity,
        payload: {
          product_id: this.playcardProductId,
          count: this.playcardQuantity,
        },
        editable: true,
        attributes: {
          product: this.playcardProduct,
        },
      }

      if (this.editMode) {
        item.id = this.editItem.id
      }

      return item
    },

    addPlaycardCartItem(item) {
      this.isAddingToCart = true
      this.addCartItem(item)
    },
  },
}
